import React from 'react'
import TabBar from 'components/atoms/TabBar'

const TabbedContent = ({ items = [], props = {}, noMargin, topTabbar }) => {
	
	return (
		<TabBar
			topTabbar={ topTabbar }
			items={ items }
			props={ props }
			noMargin={ noMargin }
		/>
	)
}

export default TabbedContent
